import { useState } from 'react';
import { ICampaignDeliverables, ITemplate } from '../../../interfaces/campaign.interface';
import { Button, Image, OverlayTrigger, Tooltip } from 'react-bootstrap';
import TemplateOrTagsModal from '../../templateOrTagsModal/TemplateOrTagsModal';

interface IProps {
    deliverable: ICampaignDeliverables;
    updateDeliverableTags: (tags: string[]) => void;
    updateDeliverableTemplate: (templateDetail: ITemplate | null) => void;
    updateDeliverableTagsAndTemplate: (tags: string[], templateDetail: ITemplate | null) => void;
}

const AttachTemplateOrTags = ({
    deliverable,
    updateDeliverableTags,
    updateDeliverableTemplate,
    updateDeliverableTagsAndTemplate,
}: IProps) => {
    const [showModal, setShowModal] = useState(false);

    const onHide = () => {
        setShowModal(false);
    };
    const onShow = () => {
        setShowModal(true);
    };

    return (
        <>
            {deliverable.templateDetails && deliverable.templateDetails.preview_url.length > 0 ? (
                <div className="tw-w-full tw-h-full tw-relative tw-group">
                    <Image
                        src={deliverable.templateDetails.preview_url}
                        fluid
                        className="tw-w-full tw-h-full tw-rounded-l-md"
                    />
                    <div
                        className="tw-absolute tw-inset-0 tw-bg-gray-700/40 tw-rounded-l-md tw-flex tw-items-start tw-justify-end tw-p-1 tw-opacity-0 tw-transition-opacity group-hover:tw-opacity-100 tw-cursor-pointer"
                        onClick={onShow}
                    >
                        <div
                            onClick={(e) => {
                                e.stopPropagation();
                                updateDeliverableTemplate(null);
                            }}
                            className="tw-w-9 tw-h-9 tw-rounded-full tw-flex tw-items-center tw-justify-center hover:tw-bg-white/30 tw-transition"
                        >
                            <i className="ph-bold ph-x-circle tw-text-white tw-text-2xl"></i>
                        </div>
                    </div>
                </div>
            ) : (
                <OverlayTrigger
                    placement="right"
                    overlay={<Tooltip id="button-tooltip-2">Select Template or Tags</Tooltip>}
                    trigger={['hover', 'focus']}
                >
                    <div
                        className="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-bg-gray-100 tw-cursor-pointer"
                        onClick={onShow}
                    >
                        <div className="tw-p-3 tw-bg-[#E5E7EB] tw-rounded-full tw-flex tw-items-center tw-justify-center">
                            <i className="ph-bold ph-image-square lg tw-text-[#9CA3AF]"></i>
                        </div>
                    </div>
                </OverlayTrigger>
            )}
            {showModal && (
                <TemplateOrTagsModal
                    show={showModal}
                    onHide={onHide}
                    deliverable={deliverable}
                    updateDeliverableTagsAndTemplate={updateDeliverableTagsAndTemplate}
                />
            )}
        </>
    );
};

export default AttachTemplateOrTags;
